import React from "react";
import { Button } from "@fluentui/react-components";
import { PeopleRegular, PersonAddRegular, DismissRegular } from "@fluentui/react-icons";
import styles from "./customerField.module.scss";
import { useTranslation } from "../../shared/translation/Translation";
import AntiXssTextField from "../textField/AntiXssTextField";
import { ICustomer } from "../../models/Customer";

export interface CustomerFieldProps {
    customer: ICustomer;
    isFormTypeUpdate: boolean;
    isCorporateMeeting: boolean;

    handleDataChange: (value: ICustomer) => void;
    handleDelete: (key: string) => void;
}

const CustomerField: React.FC<CustomerFieldProps> = (props: CustomerFieldProps) => {
    const messages = useTranslation();

    const handleOnChange = (field: string, value: string) => {
        props.customer[field] = value;
        props.handleDataChange(props.customer);
    };

    return (
        <div className={styles.fieldRow}>
            <div className={styles.iconWrapper}>
                {props.isFormTypeUpdate ? <PeopleRegular /> : <PersonAddRegular />}
            </div>
            <AntiXssTextField
                autoComplete="name-off"
                placeholder={messages.meetingModals.customerNamePlaceholder}
                className={styles.inputComponent}
                isInvalid={props.customer.name.length > 0 && !props.customer.validateName()}
                handleDataChange={(value) => handleOnChange("name", value)}
                text={props.customer.name}
                required={true}
                disabled={props.isFormTypeUpdate && !props.customer.isNew}
                showSuccessIndicator={props.customer.validateName()}
            />
            <AntiXssTextField
                autoComplete="email-off"
                placeholder={messages.meetingModals.customerEmailPlaceholder}
                className={styles.inputComponent}
                isInvalid={props.customer.email.length > 0 && !props.customer.validateEmail()}
                handleDataChange={(value) => handleOnChange("email", value)}
                text={props.customer.email}
                required={true}
                errorMessage={messages.meetingModals.validation.invalidEmail}
                disabled={props.isFormTypeUpdate && !props.customer.isNew}
                showSuccessIndicator={props.customer.validateEmail()}
            />
            {props.isCorporateMeeting ? null : (
                <AntiXssTextField
                    autoComplete="id-off"
                    placeholder={messages.meetingModals.customerIdPlaceholder}
                    className={styles.inputComponent}
                    isInvalid={!props.customer.validateId()}
                    errorMessage={messages.meetingModals.validation.invalidClientId}
                    handleDataChange={(value) => handleOnChange("id", value)}
                    text={props.customer.id ?? ""}
                    disabled={props.isFormTypeUpdate && !props.customer.isNew}
                    showSuccessIndicator={props.customer.validateId()}
                />
            )}
            <Button
                title="Delete"
                className={styles.buttonComponent}
                icon={<DismissRegular />}
                appearance="transparent"
                onClick={() => props.handleDelete(props.customer.key)}
                disabled={props.isFormTypeUpdate && !props.customer.isNew}
            />
        </div>
    );
};

export default CustomerField;
